"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizableHeader = exports.ResizableHeaderUnstyled = void 0;
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const throttle_debounce_1 = require("throttle-debounce");
require("./resizable-header.less");
const decorate = material_ui_1.withStyles(theme => ({
    withMargin: {
        margin: "0 0"
    },
    root: {},
    resizableHeader: {
        "background": "#b5b5b5",
        "paddingTop": "0",
        "paddingBottom": "0",
        "margin": "0",
        "height": "5px",
        "&::after": {
            content: ".",
            width: "0px",
            height: "0px",
            position: "absolute",
            bottom: "5px",
            right: "-2.5px",
            borderLeft: "5px solid transparent",
            borderRight: "5px solid transparent",
            borderTop: "5px solid #646569 "
        }
    }
    // resizeTip: {
    //   "&:before": {
    //     borderBottomColor: "#fff",
    //     position: "absolute",
    //     top: "-19px",
    //     left: "255px",
    //     zIndex: "2"
    //   }
    // }
}));
let ResizableHeaderUnstyled = class ResizableHeaderUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.tableRows = [];
        this.updateResizableGrid = () => {
            this.tableRows = [];
            const tableList = this.props.tableListRef;
            if (!tableList) {
                this.renderInterval = window.setTimeout(this.makeResizable, 1000);
                return;
            }
            window.clearInterval(this.renderInterval);
            // const unorderedLists = tableList.getElementsByTagName("ul");
            // const materialLists = tableList.getElementsByClassName("material-list");
            const [materialList] = tableList.getElementsByClassName("material-list");
            // for (const ul of unorderedLists) {
            //   this.makeResizableGrid(ul);
            // }
            if (materialList) {
                this.makeResizableGrid(materialList);
            }
            else {
                console.error("materialList not found");
            }
        };
        this.makeResizable = () => {
            this.updateResizableGrid();
        };
        this.makeResizableGrid = (ul) => {
            const rows = ul.getElementsByTagName("li");
            // console.info('rows.length from getElementsByTagName(li)', rows.length);
            for (const row of rows) {
                let isResizableHeader = false;
                if (row.classList.contains("resizable-header")) {
                    isResizableHeader = true;
                }
                const cols = row ? row.children : null;
                if (!cols)
                    return;
                // ul.style.overflow = "hidden";
                // const tableHeight = ul.offsetHeight;
                const tableHeight = "5";
                const resizableCells = [];
                let index = 0;
                for (const col of cols) {
                    const div = this.createDiv(tableHeight, isResizableHeader);
                    // Set listener only for resizable heade row
                    if (isResizableHeader) {
                        this.setListeners(div, index++);
                    }
                    col.appendChild(div);
                    col.style.position = "relative";
                    resizableCells.push(div);
                }
                this.tableRows.push(resizableCells);
            }
        };
        this.setListeners = (div, index) => {
            let pageX;
            let curCol;
            let nxtCol;
            let curColWidth;
            let nxtColWidth;
            let cancel = true;
            div.addEventListener("mousedown", (e) => {
                cancel = false;
                curCol = e.target.parentElement;
                pageX = e.pageX;
                // console.info('curCol is', curCol);
                if (!curCol) {
                    console.error("-----ERROR-----");
                    return;
                }
                const padding = this.paddingDiff(curCol);
                curColWidth = curCol.offsetWidth - padding;
                nxtCol = curCol.nextElementSibling;
                if (nxtCol) {
                    nxtColWidth = nxtCol.offsetWidth - padding;
                }
                const indexDivs = [];
                // console.info("this.tableRows", this.tableRows);
                for (const d of this.tableRows) {
                    if (d[index]) {
                        indexDivs.push(d[index]);
                    }
                }
                if (indexDivs && indexDivs.length) {
                    for (const div of indexDivs) {
                        const curCol = div.parentElement;
                        const nxtCol = div.nextElementSibling;
                        pageX = e.pageX;
                        const padding = this.paddingDiff(curCol);
                        if (nxtCol) {
                            curColWidth = nxtCol.offsetWidth - padding;
                            nxtColWidth = nxtCol.offsetWidth - padding;
                        }
                        // console.group("mousemove");
                        // console.info("curCol", curCol);
                        // console.info("nxtCol", nxtCol);
                        // console.info("curColWidth", curColWidth);
                        // console.info("nxtColWidth", nxtColWidth);
                        // console.groupEnd();
                    }
                }
            });
            div.addEventListener("mouseover", (e) => {
                // e.currentTarget.style.borderRight = "2px solid #0000ff";
            });
            div.addEventListener("mouseout", (e) => {
                // e.currentTarget.style.borderRight = "";
            });
            document.addEventListener("mousemove", e => {
                if (cancel) {
                    return;
                }
                let diffX;
                if (curCol) {
                    diffX = e.pageX - pageX;
                    if (nxtCol) {
                        nxtCol.style.flexBasis = `${nxtColWidth - diffX}px`;
                    }
                    curCol.style.flexBasis = `${curColWidth + diffX}px`;
                }
                const indexDivs = [];
                for (const colDivsArray of this.tableRows) {
                    // filter out header row
                    const currentDiv = colDivsArray[index];
                    const isHeaderRowColumn = currentDiv &&
                        currentDiv.parentElement &&
                        currentDiv.parentElement &&
                        currentDiv.parentElement.parentElement &&
                        currentDiv.parentElement.parentElement.classList.contains("tkay-group-header");
                    if (currentDiv && !isHeaderRowColumn) {
                        indexDivs.push(colDivsArray[index]);
                    }
                }
                if (indexDivs) {
                    for (const div of indexDivs) {
                        if (curCol) {
                            if (nxtCol) {
                                if (div &&
                                    div.parentElement &&
                                    div.parentElement.nextElementSibling) {
                                    div.parentElement.nextElementSibling.style.flexBasis = `${nxtColWidth -
                                        diffX}px`;
                                }
                            }
                            if (div && div.parentElement) {
                                div.parentElement.style.flexBasis = `${curColWidth + diffX}px`;
                            }
                        }
                    }
                }
            });
            document.addEventListener("mouseup", e => {
                cancel = true;
                curCol = null;
                nxtCol = null;
                pageX = null;
                nxtColWidth = null;
                curColWidth = null;
            });
            // const indexDivs = this.tableRows[index];
            // if (indexDivs) {
            //   for (const div of this.tableRows) {
            //     curCol = div.parentElement;
            //     nxtCol = div.nextElementSibling;
            //   }
            // }
        };
        this.createDiv = (height, isResizableHeader) => {
            const div = document.createElement("div");
            // div.style.top = "0";
            div.style.right = "2px";
            div.style.width = "5px";
            div.style.position = "absolute";
            if (isResizableHeader) {
                div.style.cursor = "col-resize";
                // div.style.background = '#e9ebf1';
                div.style.background = "#646569";
                div.style.userSelect = "none";
                div.classList.add("resizable-table-cursor-resize");
                div.addEventListener("click", throttle_debounce_1.debounce(200, this.updateResizableGrid));
            }
            div.style.height = height + "px";
            return div;
        };
        this.paddingDiff = (col) => {
            if (this.getStyleVal(col, "box-sizing") === "border-box") {
                return 0;
            }
            const padLeft = this.getStyleVal(col, "padding-left");
            const padRight = this.getStyleVal(col, "padding-right");
            return parseInt(padLeft, 10) + parseInt(padRight, 10);
        };
        this.getStyleVal = (elm, css) => window.getComputedStyle(elm, null).getPropertyValue(css);
        this.renderHeaderResizable = () => {
            const { columns = [], withMargin = false } = this.props;
            return (React.createElement("div", null,
                React.createElement(list_item_1.MaterialListItem, { className: `${this.props.classes.resizableHeader} resizable-header`, category: withMargin
                        ? list_item_1.IListItemCategory.Header
                        : list_item_1.IListItemCategory.HeaderNoMargin }, columns.map((column, index) => (React.createElement("div", { 
                    // onClick={this.updateResizableGrid}
                    className: `material-list__header-item ` + (column.className || ""), key: index },
                    React.createElement(list_item_text_1.MaterialListItemText, { header: true, primary: "" })))))));
        };
    }
    componentDidMount() {
        this.makeResizable();
    }
    componentWillReceiveProps() {
        this.makeResizable();
    }
    render() {
        return this.renderHeaderResizable();
    }
};
__decorate([
    mobx_1.observable
], ResizableHeaderUnstyled.prototype, "renderInterval", void 0);
ResizableHeaderUnstyled = __decorate([
    mobx_react_1.observer
], ResizableHeaderUnstyled);
exports.ResizableHeaderUnstyled = ResizableHeaderUnstyled;
exports.ResizableHeader = decorate(ResizableHeaderUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/resizable-header/resizable-header.tsx
// module id = 3233
// module chunks = 0